export default __webpack_public_path__ + "static/media/Factory.134fb8f9.svg";